var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLandingCardGrill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1280,
    height: 321,
    viewBox: "0 0 1280 321",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("rect", {
    y: -32,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: -32,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: -32,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: -32,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: -32,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: -32,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: -32,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: -32,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: -32,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: -32,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: -32,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352,
    y: -32,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384,
    y: -32,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: -32,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 448,
    y: -32,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480,
    y: -32,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 512,
    y: -32,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 544,
    y: -32,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576,
    y: -32,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 608,
    y: -32,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 640,
    y: -32,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 672,
    y: -32,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 704,
    y: -32,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 736,
    y: -32,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 768,
    y: -32,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 800,
    y: -32,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 832,
    y: -32,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 864,
    y: -32,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 896,
    y: -32,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 928,
    y: -32,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 960,
    y: -32,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 992,
    y: -32,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1024,
    y: -32,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1056,
    y: -32,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1088,
    y: -32,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1120,
    y: -32,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1152,
    y: -32,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1184,
    y: -32,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1216,
    y: -32,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1248,
    y: -32,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1280,
    y: -32,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 448,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 512,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 544,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 608,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 640,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 672,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 704,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 736,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 768,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 800,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 832,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 864,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 896,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 928,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 960,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 992,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1024,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1056,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1088,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1120,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1152,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1184,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1216,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1248,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1280,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    y: 32,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 32,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 32,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 32,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 32,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 32,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 32,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 32,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 32,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 32,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 32,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352,
    y: 32,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384,
    y: 32,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 32,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 448,
    y: 32,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480,
    y: 32,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 512,
    y: 32,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 544,
    y: 32,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576,
    y: 32,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 608,
    y: 32,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 640,
    y: 32,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 672,
    y: 32,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 704,
    y: 32,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 736,
    y: 32,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 768,
    y: 32,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 800,
    y: 32,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 832,
    y: 32,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 864,
    y: 32,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 896,
    y: 32,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 928,
    y: 32,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 960,
    y: 32,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 992,
    y: 32,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1024,
    y: 32,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1056,
    y: 32,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1088,
    y: 32,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1120,
    y: 32,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1152,
    y: 32,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1184,
    y: 32,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1216,
    y: 32,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1248,
    y: 32,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1280,
    y: 32,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    y: 64,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 64,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 64,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 64,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 64,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 64,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 64,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 64,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 64,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 64,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 64,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352,
    y: 64,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384,
    y: 64,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 64,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 448,
    y: 64,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480,
    y: 64,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 512,
    y: 64,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 544,
    y: 64,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576,
    y: 64,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 608,
    y: 64,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 640,
    y: 64,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 672,
    y: 64,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 704,
    y: 64,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 736,
    y: 64,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 768,
    y: 64,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 800,
    y: 64,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 832,
    y: 64,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 864,
    y: 64,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 896,
    y: 64,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 928,
    y: 64,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 960,
    y: 64,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 992,
    y: 64,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1024,
    y: 64,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1056,
    y: 64,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1088,
    y: 64,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1120,
    y: 64,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1152,
    y: 64,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1184,
    y: 64,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1216,
    y: 64,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1248,
    y: 64,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1280,
    y: 64,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    y: 96,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 96,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 96,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 96,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 96,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 96,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 96,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 96,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 96,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 96,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 96,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352,
    y: 96,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384,
    y: 96,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 96,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 448,
    y: 96,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480,
    y: 96,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 512,
    y: 96,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 544,
    y: 96,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576,
    y: 96,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 608,
    y: 96,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 640,
    y: 96,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 672,
    y: 96,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 704,
    y: 96,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 736,
    y: 96,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 768,
    y: 96,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 800,
    y: 96,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 832,
    y: 96,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 864,
    y: 96,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 896,
    y: 96,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 928,
    y: 96,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 960,
    y: 96,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 992,
    y: 96,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1024,
    y: 96,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1056,
    y: 96,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1088,
    y: 96,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1120,
    y: 96,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1152,
    y: 96,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1184,
    y: 96,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1216,
    y: 96,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1248,
    y: 96,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1280,
    y: 96,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    y: 128,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 128,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 128,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 128,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 128,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 128,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 128,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 128,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 128,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 128,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 128,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352,
    y: 128,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384,
    y: 128,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 128,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 448,
    y: 128,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480,
    y: 128,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 512,
    y: 128,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 544,
    y: 128,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576,
    y: 128,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 608,
    y: 128,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 640,
    y: 128,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 672,
    y: 128,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 704,
    y: 128,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 736,
    y: 128,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 768,
    y: 128,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 800,
    y: 128,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 832,
    y: 128,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 864,
    y: 128,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 896,
    y: 128,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 928,
    y: 128,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 960,
    y: 128,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 992,
    y: 128,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1024,
    y: 128,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1056,
    y: 128,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1088,
    y: 128,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1120,
    y: 128,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1152,
    y: 128,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1184,
    y: 128,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1216,
    y: 128,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1248,
    y: 128,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1280,
    y: 128,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    y: 160,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 160,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 160,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 160,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 160,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 160,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 160,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 160,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 160,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 160,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 160,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352,
    y: 160,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384,
    y: 160,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 160,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 448,
    y: 160,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480,
    y: 160,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 512,
    y: 160,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 544,
    y: 160,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576,
    y: 160,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 608,
    y: 160,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 640,
    y: 160,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 672,
    y: 160,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 704,
    y: 160,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 736,
    y: 160,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 768,
    y: 160,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 800,
    y: 160,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 832,
    y: 160,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 864,
    y: 160,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 896,
    y: 160,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 928,
    y: 160,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 960,
    y: 160,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 992,
    y: 160,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1024,
    y: 160,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1056,
    y: 160,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1088,
    y: 160,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1120,
    y: 160,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1152,
    y: 160,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1184,
    y: 160,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1216,
    y: 160,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1248,
    y: 160,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1280,
    y: 160,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    y: 192,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 192,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 192,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 192,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 192,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 192,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 192,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 192,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 192,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 192,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 192,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352,
    y: 192,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384,
    y: 192,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 192,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 448,
    y: 192,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480,
    y: 192,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 512,
    y: 192,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 544,
    y: 192,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576,
    y: 192,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 608,
    y: 192,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 640,
    y: 192,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 672,
    y: 192,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 704,
    y: 192,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 736,
    y: 192,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 768,
    y: 192,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 800,
    y: 192,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 832,
    y: 192,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 864,
    y: 192,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 896,
    y: 192,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 928,
    y: 192,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 960,
    y: 192,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 992,
    y: 192,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1024,
    y: 192,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1056,
    y: 192,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1088,
    y: 192,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1120,
    y: 192,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1152,
    y: 192,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1184,
    y: 192,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1216,
    y: 192,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1248,
    y: 192,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1280,
    y: 192,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    y: 224,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 224,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 224,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 224,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 224,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 224,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 224,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 224,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 224,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 224,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 224,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352,
    y: 224,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384,
    y: 224,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 224,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 448,
    y: 224,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480,
    y: 224,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 512,
    y: 224,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 544,
    y: 224,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576,
    y: 224,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 608,
    y: 224,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 640,
    y: 224,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 672,
    y: 224,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 704,
    y: 224,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 736,
    y: 224,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 768,
    y: 224,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 800,
    y: 224,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 832,
    y: 224,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 864,
    y: 224,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 896,
    y: 224,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 928,
    y: 224,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 960,
    y: 224,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 992,
    y: 224,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1024,
    y: 224,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1056,
    y: 224,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1088,
    y: 224,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1120,
    y: 224,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1152,
    y: 224,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1184,
    y: 224,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1216,
    y: 224,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1248,
    y: 224,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1280,
    y: 224,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    y: 256,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 256,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 256,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 256,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 256,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 256,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 256,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 256,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 256,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 256,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 256,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352,
    y: 256,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384,
    y: 256,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 256,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 448,
    y: 256,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480,
    y: 256,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 512,
    y: 256,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 544,
    y: 256,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576,
    y: 256,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 608,
    y: 256,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 640,
    y: 256,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 672,
    y: 256,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 704,
    y: 256,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 736,
    y: 256,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 768,
    y: 256,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 800,
    y: 256,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 832,
    y: 256,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 864,
    y: 256,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 896,
    y: 256,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 928,
    y: 256,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 960,
    y: 256,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 992,
    y: 256,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1024,
    y: 256,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1056,
    y: 256,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1088,
    y: 256,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1120,
    y: 256,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1152,
    y: 256,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1184,
    y: 256,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1216,
    y: 256,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1248,
    y: 256,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1280,
    y: 256,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    y: 288,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 288,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 288,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 288,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 288,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 288,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 288,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 288,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 288,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 288,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 288,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352,
    y: 288,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384,
    y: 288,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 288,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 448,
    y: 288,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480,
    y: 288,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 512,
    y: 288,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 544,
    y: 288,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576,
    y: 288,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 608,
    y: 288,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 640,
    y: 288,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 672,
    y: 288,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 704,
    y: 288,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 736,
    y: 288,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 768,
    y: 288,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 800,
    y: 288,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 832,
    y: 288,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 864,
    y: 288,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 896,
    y: 288,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 928,
    y: 288,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 960,
    y: 288,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 992,
    y: 288,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1024,
    y: 288,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1056,
    y: 288,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1088,
    y: 288,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1120,
    y: 288,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1152,
    y: 288,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1184,
    y: 288,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1216,
    y: 288,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1248,
    y: 288,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1280,
    y: 288,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    y: 320,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 320,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 320,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 320,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 320,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 320,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 320,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 320,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 320,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 320,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 320,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352,
    y: 320,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384,
    y: 320,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 320,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 448,
    y: 320,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480,
    y: 320,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 512,
    y: 320,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 544,
    y: 320,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576,
    y: 320,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 608,
    y: 320,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 640,
    y: 320,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 672,
    y: 320,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 704,
    y: 320,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 736,
    y: 320,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 768,
    y: 320,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 800,
    y: 320,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 832,
    y: 320,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 864,
    y: 320,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 896,
    y: 320,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 928,
    y: 320,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 960,
    y: 320,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 992,
    y: 320,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1024,
    y: 320,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1056,
    y: 320,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1088,
    y: 320,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1120,
    y: 320,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1152,
    y: 320,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1184,
    y: 320,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1216,
    y: 320,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1248,
    y: 320,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1280,
    y: 320,
    width: 32,
    height: 32,
    stroke: "#85A9EF",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingCardGrill);
export default __webpack_public_path__ + "static/media/LandingCardGrill.9f9ee900e268ca4f40d1901ddba18f58.svg";
export { ForwardRef as ReactComponent };